import React, { useEffect, useState } from "react";
import loaderGif from "../../../../../assets/images/loader.gif";
import { format } from "date-fns";
import ApiCallServices from "../../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../../services/endpoint/endPoint";
import {Tooltip, Box, Typography} from '@mui/material';
import { tooltipMap } from '../../../../common/constants';
const DataListing = ({
  tableData,
  onSort,
  patrners,
  sortingColumn,
  sortingOrder,
  loader,
  applyDateRange,
  currency,
}) => {
  console.log(patrners)
  const [currentCurrency, setCurrentCurrency] = useState(currency);
  let userCurrency = JSON.parse(localStorage.getItem("user"));
  const [expandedRows, setExpandedRows] = useState([]); // State to track expanded rows
  const [expandedData, setExpandedData] = useState({});
  // const [currency, setCurrency] = useState(userCurrency?.currency == "BASE" ? "BASE" : "INR");

  const renderSortIcon = (column) => {
    if (sortingColumn === column) {
      return sortingOrder === "asc" ? (
        <i className="fa-solid fa-sort-up"></i>
      ) : (
        <i className="fa-solid fa-sort-down"></i>
      );
    }
    return <i className="fa-solid fa-sort"></i>;
  };

  const parseNumber = (str) => {
    if (!str) return 0;
    return parseFloat(str.replace(/,/g, ""));
  };

  function transformText(str) {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const sortedTableData =
    tableData.tableData && tableData.tableData.length > 0
      ? [...tableData.tableData].sort((a, b) => {
          const aValue =
            sortingColumn === "deal_name"
              ? a[sortingColumn]
              : sortingColumn === "impressions"
              ? parseInt(a[sortingColumn])
              : parseNumber(a[sortingColumn]);
          const bValue =
            sortingColumn === "deal_name"
              ? b[sortingColumn]
              : sortingColumn === "impressions"
              ? parseInt(b[sortingColumn])
              : parseNumber(b[sortingColumn]);

          if (aValue < bValue) {
            return sortingOrder === "asc" ? -1 : 1;
          } else if (aValue > bValue) {
            return sortingOrder === "asc" ? 1 : -1;
          } else {
            return 0;
          }
        })
      : [];

  useEffect(() => {
    setExpandedRows([]);
    setExpandedData({});
  }, [applyDateRange]);

  useEffect(() => {
    if (currency !== currentCurrency) {
      setCurrentCurrency(currency);
      const updatedExpandedData = {};
      const promises = expandedRows.map(async (rowIndex) => {
        const dealId = tableData.tableData[rowIndex].deal_id;
        return toggleRow(rowIndex, dealId, true, updatedExpandedData);
      });

      Promise.all(promises).then(() => {
        setExpandedData(updatedExpandedData);
      });
    }
  }, [currency]);

  const toggleRow = async (rowIndex, dealId) => {
    if (expandedRows.includes(rowIndex)) {
      // Collapse the row
      setExpandedRows(expandedRows.filter((index) => index !== rowIndex));
    } else {
      // Check if data for this dealId is already fetched
      if (!expandedData[dealId]) {
        try {
          // Fetch the data directly
          const data = {
            startDateRange: `${format(applyDateRange.startDate, "MM/dd/yyyy")}`,
            endDateRange: `${format(applyDateRange.endDate, "MM/dd/yyyy")}`,

            tr_deal_id: dealId,
            currency: currency,
          };
          const response = await ApiCallServices.create(
            END_POINTS.adomainList,
            data
          );

          if (response.status === 200 && response.data?.data?.data) {
            const fetchedData = response.data.data.data;

            // Update expandedData directly with fetched data
            setExpandedData((prev) => ({
              ...prev,
              [dealId]: fetchedData,
            }));

            // Expand the row
            setExpandedRows([...expandedRows, rowIndex]);
          } else {
            console.error("Failed to fetch adomain data:", response);
          }
        } catch (error) {
          console.error("Error fetching adomain data:", error);
        }
      } else {
        // If data is already fetched, simply expand the row
        setExpandedRows([...expandedRows, rowIndex]);
      }
    }
  };

  console.log(expandedData, "***expandedData===>", expandedRows);
  return (
    <>
      <div className="table-responsive custom-table h50">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th className="partner" onClick={() => onSort("name")}>
                Brand {renderSortIcon("name")}
              </th>
              <th className="deal-name" onClick={() => onSort("deal_name")}>
                Deal Name {renderSortIcon("deal_name")}
              </th>
              {tableData.privillage &&
                tableData.privillage.map((item, i) => {
                  return (
                    <th className="margin" onClick={() => onSort(item)}>
                      <Tooltip 
                          title={
                            <Box>
                              <Typography sx={{ fontWeight: 600, fontSize: "14px", textTransform:'capitalize'}}>
                              {tooltipMap?.[item]?.title}
                              </Typography>
                              <Typography sx={{ fontSize: "12px", opacity: 0.8 }}>
                                {tooltipMap?.[item]?.body} 
                              </Typography>
                            </Box>
                          }
                          placement="top">
                          <i className="fa-solid fa-info-circle rounded" style={{ cursor: "pointer" }} ></i>
                        </Tooltip>  &nbsp;
                        {item == "cpm" && (
                        <span className="cardMenuecpm">eCPM &nbsp;</span>
                      )}
                      {item != "cpm" && (
                        <span className="cardMenu">{transformText(item)}  </span>
                      )}
                      {renderSortIcon(item)} : &nbsp;
                    </th>
                  );
                })}
              {/* <th onClick={() => onSort('impressions')}>Impressions {renderSortIcon('impressions')}</th>
              <th onClick={() => onSort('revenue')}>Media Spend {renderSortIcon('revenue')}</th>
              <th onClick={() => onSort('media_cost')}>Media Cost {renderSortIcon('media_cost')}</th>
              <th onClick={() => onSort('margin')}>Margin {renderSortIcon('margin')}</th> */}
            </tr>
          </thead>
          {!loader ? (
            <>
              <tbody>
                {sortedTableData.length > 0 ? (
                  sortedTableData.map((item, i) => (
                    <React.Fragment key={i}>
                      <tr key={i}>
                        <td>{i + 1} </td>
                        <td className="wrap-string partner"> {item?.name}</td>
                        <td className="wrap-string deal-name">
                          {" "}
                          {item?.adomain_view == 1 && (
                            <i
                              className={`fa ${
                                expandedRows.includes(i)
                                  ? "fa-minus-circle"
                                  : "fa-plus-circle"
                              }`}
                              onClick={() => toggleRow(i, item.deal_id)}
                            ></i>
                          )}{" "}
                          {item?.deal_name}
                        </td>
                        {tableData.privillage &&
                          tableData.privillage.map((key) => {
                            return (
                              <td className="text-end margin">

                                <span style={{display:'inline', fontWeight:'bold'}}>{key != "impressions" &&patrners?.[0]?.currency_sign}</span>
                                {item[key]}{" "}
                                {key == "savings" ? (
                                  <strong className="blue">
                                    ({item?.margin_percentage}%)
                                  </strong>
                                ) : (
                                  ""
                                )}
                                {key === "advertiser_cost" &&
                                  item?.growth_percentage !== undefined && (
                                    <span
                                      className={
                                        item.growth_percentage >= 0
                                          ? "overview-growth-percentage positive"
                                          : "overview-growth-percentage negative"
                                      }
                                    >
                                      <span>
                                        {item.growth_percentage >= 0
                                          ? "↑"
                                          : "↓"}
                                      </span>
                                      {Math.abs(item.growth_percentage)}%
                                    </span>
                                  )}
                                  
                                  {key == "cpm" && <strong className="blue">&nbsp; (avg.)</strong>}
                              </td>
                            );
                          })}
                      </tr>

                      {/* Expanded Row */}
                      {expandedRows.includes(i) && (
                        <tr>
                          <td colSpan="9" className="expand_td">
                            <div className="expanded-row">
                              {expandedData[item.deal_id] ? (
                                <>
                                  <div className="head d-flex justify-content-between">
                                    <p>Adomain</p>
                                    <p>Advertiser Cost</p>
                                    <p>Savings</p>
                                    <p>Media Cost</p>
                                  </div>
                                  <div className="contentWraper">
                                    {expandedData[item?.deal_id].map(
                                      (adomainItem, idx) => (
                                        <div
                                          key={idx}
                                          className="content d-flex justify-content-between"
                                        >
                                          <p>
                                            {adomainItem.adomain_name || "N/A"}
                                          </p>
                                          <p>{adomainItem.revenue || "N/A"}</p>
                                          <p>{adomainItem.savings || "N/A"}</p>
                                          <p>
                                            {adomainItem.media_cost || "N/A"}
                                          </p>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </>
                              ) : (
                                <p>Loading...</p>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
              {tableData.totalSumation &&
                tableData.totalSumation.map((item, i) => (
                  <tfoot>
                    <tr key={i}>
                      <th className="gtotal" colSpan={3}>Grand Total : </th>
                      {tableData.privillage &&
                        tableData.privillage.map((key) => {
                          return <th className="text-end">{item[key]}</th>;
                        })}
                    </tr>
                  </tfoot>
                ))}
            </>
          ) : (
            <div className={`loader ${loader ? "show" : ""}`}>
              <label>
                <img src={loaderGif} />
              </label>
            </div>
          )}
        </table>
      </div>
    </>
  );
};

export default DataListing;
